(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ikh-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ikhInit) return;
      root.dataset.ikhInit = '1';
      var items = root.querySelectorAll('.ikh-ann__item');
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        items[i].classList.remove('is-on');
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
      }, 3500);
    }
    function initAll() { document.querySelectorAll('[data-ikh-ann]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikh-hs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(r) {
      if (r.dataset.ikhInit) return; r.dataset.ikhInit = '1';
      var ss = r.querySelectorAll('.ikh-hs__s'), ds = r.querySelectorAll('.ikh-hs__dots button'), i = 0, t;
      if (ss.length < 2) return;
      var ms = (parseInt(r.dataset.speed, 10) || 5) * 1000;
      function go(k) { i = (k + ss.length) % ss.length; ss.forEach(function (s, j) { s.classList.toggle('is-on', j === i); }); ds.forEach(function (d, j) { d.classList.toggle('on', j === i); }); restart(); }
      function restart() { clearInterval(t); t = setInterval(function () { go(i + 1); }, ms); }
      ds.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
      var a = r.querySelectorAll('.ikh-hs__a');
      if (a.length === 2) { a[0].addEventListener('click', function () { go(i - 1); }); a[1].addEventListener('click', function () { go(i + 1); }); }
      var x0 = null;
      r.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      r.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
      r.addEventListener('mouseenter', function () { clearInterval(t); });
      r.addEventListener('mouseleave', restart);
      // start autoplay only after the page has loaded, so slide 1 stays the LCP image
      if (document.readyState === 'complete') restart(); else window.addEventListener('load', restart, { once: true });
    }
    function all() { document.querySelectorAll('[data-ikh-hs]').forEach(init); }
    if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikh-main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(form) {
      if (form.dataset.ikhInit) return;
      form.dataset.ikhInit = '1';
      var real = document.getElementById('ikh-col-form');
      form.querySelectorAll('[data-ikh-col-auto]').forEach(function (el) {
        el.addEventListener('change', function () { real.requestSubmit ? real.requestSubmit() : real.submit(); });
      });
      real.addEventListener('submit', function () {
        form.querySelectorAll('input[type=number]').forEach(function (i) { if (!i.value) i.disabled = true; });
      });
      var panel = form.querySelector('[data-ikh-col-panel]');
      var toggle = form.querySelector('[data-ikh-col-toggle]');
      var close = form.querySelector('[data-ikh-col-close]');
      function set(open) {
        panel.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.classList.toggle('ikh-noscroll', open);
      }
      if (toggle) toggle.addEventListener('click', function () { set(true); });
      if (close) close.addEventListener('click', function () { set(false); });
    }
    // infinite scroll: load the next page's cards when the visitor nears the end of the grid (the pager stays as a no-JS fallback)
    function infinite(form) {
      var more = form.querySelector('[data-ikh-col-more]');
      var grid = form.querySelector('.ikh-col__grid');
      if (!more || !grid || !('IntersectionObserver' in window)) return;
      var pages = form.querySelector('.ikh-col__pages');
      if (pages) pages.style.display = 'none';
      var busy = false;
      function load() {
        var next = more.dataset.next;
        if (busy || !next) return;
        busy = true; more.classList.add('is-loading');
        fetch(next, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('.ikh-col__grid > li').forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
          var nm = doc.querySelector('[data-ikh-col-more]');
          if (nm && nm.dataset.next) more.dataset.next = nm.dataset.next; else { delete more.dataset.next; more.classList.add('is-done'); }
          document.dispatchEvent(new CustomEvent('shopify:section:load'));
        }).catch(function () { if (pages) pages.style.display = ''; }).finally(function () { busy = false; more.classList.remove('is-loading'); var r = more.getBoundingClientRect(); if (more.dataset.next && r.top < window.innerHeight + 900) load(); });
      }
      new IntersectionObserver(function (es) { if (es[0].isIntersecting) load(); }, { rootMargin: '900px 0px' }).observe(more);
    }
    function initAll() { document.querySelectorAll('[data-ikh-col-form]').forEach(function (f) { var first = !f.dataset.ikhInit; init(f); if (first) infinite(f); }); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikh-mobile-menu"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-ikh-mm]');
    if (!root || root.dataset.ikhInit) return;
    root.dataset.ikhInit = '1';
    // keep Horizon's own mobile drawer closed (its header icon would otherwise stay in the "X" state)
    function resetHorizon() {
      document.querySelectorAll('header-drawer details, #Details-menu-drawer-container').forEach(function (d) {
        d.classList.remove('menu-open');
        d.removeAttribute('open');
        var sm = d.querySelector('summary');
        if (sm) sm.setAttribute('aria-expanded', 'false');
      });
    }
    function open() {
      [0, 60, 400].forEach(function (t) { setTimeout(resetHorizon, t); });
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      resetHorizon();
      root.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { root.hidden = true; }, 350);
    }
    window.ikhOpenMenu = open;
    document.addEventListener('click', function (e) {
      var t = e.target.closest('summary.header__icon--menu');
      if (!t || window.matchMedia('(min-width: 990px)').matches) return;
      e.preventDefault(); e.stopPropagation();
      open();
    }, true);
    root.addEventListener('click', function (e) { if (e.target.closest('[data-ikh-mm-close]')) close(); });
    root.querySelectorAll('[data-ikh-mm-acc]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var w = b.parentNode, willOpen = !w.classList.contains('is-open');
        root.querySelectorAll('.ikh-mm__row-wrap.is-open').forEach(function (o) { o.classList.remove('is-open'); o.querySelector('[data-ikh-mm-acc]').setAttribute('aria-expanded', 'false'); });
        if (willOpen) { w.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); }
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
    root.querySelectorAll('[data-ikh-mm-tab]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-ikh-mm-tab]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-selected', x === b); });
        root.querySelectorAll('[data-ikh-mm-pane]').forEach(function (p) { p.classList.toggle('is-on', p.dataset.ikhMmPane === b.dataset.ikhMmTab); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikh-product-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(c) { return (c / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; }
    function init(root) {
      if (root.dataset.ikhInit) return;
      root.dataset.ikhInit = '1';
      var chk = root.querySelector('[data-ikh-bn-chk]');
      var tot = root.querySelector('[data-ikh-bn-total]');
      var btn = root.querySelector('[data-ikh-bn-btn]');
      if (!chk) return;
      chk.addEventListener('change', function () {
        root.querySelectorAll('[data-ikh-bn-2]').forEach(function (i) { i.disabled = !chk.checked; });
        tot.textContent = money(parseInt(tot.dataset.base, 10) + (chk.checked ? parseInt(chk.dataset.price, 10) : 0));
        btn.textContent = chk.checked ? 'İkisini birden sepete ekle' : 'Sepete ekle';
      });
    }
    function initAll() { document.querySelectorAll('[data-ikh-bn]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikh-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ikhInit) return;
      root.dataset.ikhInit = '1';
      var track = root.querySelector('[data-ikh-car-track]');
      var btns = root.querySelectorAll('.ikh-car__arrow');
      if (!track) return;
      function upd() {
        btns[0].disabled = track.scrollLeft <= 4;
        btns[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: parseInt(b.dataset.dir, 10) * track.clientWidth * 0.8 }); });
      });
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }
    function initAll() { document.querySelectorAll('[data-ikh-car]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikh-product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function addBizDays(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    var MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
    function fmt(a, b) {
      if (a.getMonth() === b.getMonth()) return a.getDate() + ' – ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
      return a.getDate() + ' ' + MONTHS[a.getMonth()] + ' – ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
    }
    function money(cents) { return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: (cents % 100 ? 2 : 0), maximumFractionDigits: 2 }) + ' TL'; }
    function init(root) {
      if (root.dataset.ikhInit) return;
      root.dataset.ikhInit = '1';
      var track = root.querySelector('[data-ikh-track]');
      // start loading the remaining gallery photos as soon as the visitor touches or scrolls the gallery (no blank slides on swipe)
      if (track) ['pointerdown', 'scroll', 'touchstart'].forEach(function (ev) { track.addEventListener(ev, function once() { track.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; }); track.removeEventListener(ev, once); }, { passive: true }); });
      var ths = root.querySelectorAll('[data-ikh-th]');
      var dots = root.querySelectorAll('.ikh-pm__dots i');
      var cur = root.querySelector('[data-ikh-cur]');
      var idx = 0;
      function mark(i) {
        idx = i;
        ths.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
        if (cur) cur.textContent = i + 1;
      }
      if (track) {
        track.addEventListener('scroll', function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, { passive: true });
        ths.forEach(function (t) {
          t.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * parseInt(t.dataset.ikhTh, 10) }); });
        });
      }
      // lightbox
      var full = [];
      try { full = JSON.parse(root.querySelector('[data-ikh-full]').textContent); } catch (e) {}
      var lb = root.querySelector('[data-ikh-lb]');
      var lbImg = root.querySelector('[data-ikh-lb-img]');
      var zoom = root.querySelector('[data-ikh-zoom]');
      if (zoom && lb && lb.showModal) {
        zoom.addEventListener('click', function () { if (full[idx]) { lbImg.src = full[idx]; lb.showModal(); } });
        lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('[data-ikh-lb-close]')) lb.close(); });
      }
      if (lb && lb.showModal && track) {
        track.addEventListener('click', function (e) {
          var sl = e.target.closest('.ikh-pm__slide'); if (!sl) return;
          var i = parseInt(sl.dataset.index, 10) || 0;
          if (full[i]) { lbImg.src = full[i]; lb.showModal(); }
        });
      }
      // catalogue photos with built-in white side bars: measure the bars on a small copy and zoom just enough to hide them
      root.querySelectorAll('[data-ikh-probe]').forEach(function (sl, k) {
        var im = new Image(); im.crossOrigin = 'anonymous';
        im.onload = function () {
          try {
            var w = im.naturalWidth, h = im.naturalHeight, c = document.createElement('canvas'); c.width = w; c.height = h;
            var cx = c.getContext('2d', { willReadFrequently: true }); cx.drawImage(im, 0, 0);
            var D = cx.getImageData(0, 0, w, h).data;
            function lum(x, y) { var o = (y * w + x) * 4; return (D[o] + D[o + 1] + D[o + 2]) / 3; }
            function flat(get, n) { var sum = 0, sq = 0; for (var i = 0; i < n; i += 2) { var v = get(i); sum += v; sq += v * v; } var c = Math.ceil(n / 2), m = sum / c; return m > 238 && Math.sqrt(Math.max(0, sq / c - m * m)) < 9; }
            function colW(x) { return flat(function (i) { return lum(x, Math.round(h * 0.15) + i); }, Math.round(h * 0.7)); }
            function rowW(y) { return flat(function (i) { return lum(Math.round(w * 0.15) + i, y); }, Math.round(w * 0.7)); }
            var l = 0; while (l < w / 3 && colW(l)) l++;
            var r = 0; while (r < w / 3 && colW(w - 1 - r)) r++;
            var t = 0; while (t < h / 3 && rowW(t)) t++;
            var b = 0; while (b < h / 3 && rowW(h - 1 - b)) b++;
            if (l + r + t + b > 2) {
              /* fit the non-white content box to a 4:5 frame (cover), centred on the content */
              var pad = 2, L = (l + pad) / w, R = (r + pad) / w, T = (t + pad) / h, B = (b + pad) / h;
              if (!l) L = 0; if (!r) R = 0; if (!t) T = 0; if (!b) B = 0;
              var ih = h / w, cw = 1 - L - R, ch = ih * (1 - T - B), FH = 1.25;
              var sc = Math.max(1 / cw, FH / ch);
              var left = 0.5 - (L + cw / 2) * sc, top = FH / 2 - (ih * T + ch / 2) * sc;
              left = Math.min(0, Math.max(1 - sc, left)); top = Math.min(0, Math.max(FH - sc * ih, top));
              var v = { '--ikh-w': (sc * 100).toFixed(2) + '%', '--ikh-h': (sc * ih / FH * 100).toFixed(2) + '%', '--ikh-l': (left * 100).toFixed(2) + '%', '--ikh-t': (top / FH * 100).toFixed(2) + '%' };
              var th = root.querySelector('[data-ikh-th="' + k + '"]');
              [sl, th].forEach(function (el) { if (!el) return; for (var key in v) el.style.setProperty(key, v[key]); el.classList.add('is-fit'); });
            }
          } catch (err) {}
        };
        im.src = sl.dataset.ikhProbe;
      });
      // quantity
      var qty = root.querySelector('.ikh-pm__qty input');
      root.querySelectorAll('[data-ikh-qty]').forEach(function (b) {
        b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.ikhQty, 10)); });
      });
      // ship dates
      var eta = root.querySelector('[data-ikh-eta]');
      if (eta) { var n = new Date(); eta.textContent = 'Kargoda: ' + fmt(addBizDays(n, parseInt(eta.dataset.min, 10)), addBizDays(n, parseInt(eta.dataset.max, 10))); }
      // mobile sticky add-to-cart: visible once the main add button scrolls out of view
      var sticky = root.querySelector('[data-ikh-sticky]');
      var add = root.querySelector('[data-ikh-add]');
      if (sticky && add && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var off = !en[0].isIntersecting;
          sticky.classList.toggle('is-on', off);
          sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
        }).observe(add);
        root.querySelector('[data-ikh-sticky-add]').addEventListener('click', function () { add.click(); });
      }
      // variant options
      var vjson = root.querySelector('[data-ikh-variants]');
      if (vjson) {
        var variants = JSON.parse(vjson.textContent);
        var idInput = root.querySelector('[data-ikh-variant-id]');
        var now2 = root.querySelector('[data-ikh-now]');
        var priceNow = root.querySelector('[data-ikh-price-now]');
        var priceWas = root.querySelector('[data-ikh-price-was]');
        root.querySelectorAll('[data-ikh-opt]').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var sel = [];
            root.querySelectorAll('[data-ikh-opt]:checked').forEach(function (c) { sel[+c.dataset.ikhOpt] = c.value; });
            var lbl = root.querySelector('[data-ikh-opt-label="' + inp.dataset.ikhOpt + '"]');
            if (lbl) lbl.textContent = inp.value;
            var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); });
            if (!v) return;
            idInput.value = v.id;
            priceNow.textContent = money(v.price);
            var inst = root.querySelector('[data-ikh-inst]'), instN = root.querySelector('[data-ikh-inst-n]');
            if (inst && instN) inst.textContent = money(Math.floor(v.price / parseInt(instN.dataset.ikhInstN, 10)));
            // main price block + mobile sticky bar follow the selected variant (Reha 30 Sep: sticky price did not update)
            var disc = v.compare_at_price > v.price, pctTxt = disc ? '%' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + ' indirim' : '';
            [['[data-ikh-price-was]', '[data-ikh-price-pct]'], ['[data-ikh-st-was]', '[data-ikh-st-pct]']].forEach(function (pair) {
              var w = root.querySelector(pair[0]), p = root.querySelector(pair[1]);
              if (w) { w.textContent = disc ? money(v.compare_at_price) : ''; w.hidden = !disc; }
              if (p) { p.textContent = pctTxt; p.hidden = !disc; }
            });
            var stNow = root.querySelector('[data-ikh-st-now]'); if (stNow) stNow.textContent = money(v.price);
            var stAdd = root.querySelector('[data-ikh-sticky-add]'); if (stAdd) { stAdd.disabled = !v.available; stAdd.textContent = v.available ? 'Sepete ekle' : 'Tükendi'; }
            add.disabled = !v.available;
            add.textContent = v.available ? 'Sepete ekle' : 'Tükendi';
            if (now2) now2.hidden = !v.available;
            var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
          });
        });
      }
    }
    function initAll() { document.querySelectorAll('[data-ikh-pm]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();
  (function () {
    // desktop photo grid: click a photo = open it full size in the lightbox
    document.addEventListener('click', function (e) {
      var im = e.target.closest('[data-ikh-pm] .ikh-pm__slide img');
      if (!im || window.matchMedia('(max-width: 989px)').matches) return;
      var root = im.closest('[data-ikh-pm]'), lb = root.querySelector('[data-ikh-lb]'), lbImg = root.querySelector('[data-ikh-lb-img]');
      var full = []; try { full = JSON.parse(root.querySelector('[data-ikh-full]').textContent); } catch (x) {}
      var i = Array.prototype.indexOf.call(root.querySelectorAll('.ikh-pm__slide'), im.closest('.ikh-pm__slide'));
      if (lb && lb.showModal && full[i]) { lbImg.src = full[i]; lb.showModal(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikh-product-similar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function load(el) {
      if (el.dataset.ikhInit || el.querySelector('.ikd-in')) return;
      el.dataset.ikhInit = '1';
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-ikh-sim]');
        if (fresh && fresh.querySelector('.ikd-in')) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    }
    function initAll() { document.querySelectorAll('[data-ikh-sim]').forEach(load); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikh-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ikhInit) return;
      root.dataset.ikhInit = '1';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.ikh-tabs__tab'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.ikh-tabs__panel'));
      function show(i) {
        tabs.forEach(function (t, k) {
          var on = k === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p, k) { p.hidden = k !== i; });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            show(n); tabs[n].focus();
          }
        });
      });
    }
    function initAll() { document.querySelectorAll('[data-ikh-tabs]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikh-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__ikhTv) return; root.__ikhTv = 1;
      var tabs = root.querySelectorAll('.ikh-tv__tab'), panels = root.querySelectorAll('.ikh-tv__panel');
      function bar(panel) {
        var row = panel.querySelector('.ikh-tv__row'), i = panel.querySelector('.ikh-tv__bar i');
        if (!row || !i) return;
        var vis = row.clientWidth / Math.max(row.scrollWidth, 1), max = row.scrollWidth - row.clientWidth;
        i.style.width = Math.max(vis * 100, 12) + '%';
        var k = max > 0 ? row.scrollLeft / max : 0;
        i.style.transform = 'translateX(' + (k * (100 / Math.max(vis, 0.12) - 100)) + '%)';
      }
      panels.forEach(function (p) { var r = p.querySelector('.ikh-tv__row'); if (r) r.addEventListener('scroll', function () { bar(p); }, { passive: true }); bar(p); });
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var n = t.getAttribute('data-tab');
          tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
          panels.forEach(function (p) { var on = p.getAttribute('data-panel') === n; p.hidden = !on; p.classList.toggle('is-on', on); if (on) bar(p); });
        });
      });
      window.addEventListener('resize', function () { panels.forEach(bar); });
    }
    function all() { document.querySelectorAll('[data-ikh-tv]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
